import React from "react";
import { Modal, Button } from "@components/index";
import { ModalTexts } from "@resources/locale";
import { addNumWord } from "@utils/index";
import { IAvailTime } from "../../types";
import styles from "./Modals.module.scss";

interface ModalsProps {
  isOpenModalNoSelectedRackets: boolean;
  setIsOpenModalNoSelectedRackets: React.Dispatch<React.SetStateAction<boolean>>;
  isOpenModalUnavailable: boolean;
  setIsOpenModalUnavailable: React.Dispatch<React.SetStateAction<boolean>>;
  unavailableQuantity: IAvailTime[];
  onCloseUnavailable: () => void;
}

export const Modals: React.FC<ModalsProps> = ({
  isOpenModalNoSelectedRackets,
  setIsOpenModalNoSelectedRackets,
  isOpenModalUnavailable,
  setIsOpenModalUnavailable,
  unavailableQuantity,
  onCloseUnavailable,
}) => {
  const unavailableQuantityList = unavailableQuantity.map((item: IAvailTime, i: number) => (
    <li key={i}>
      на {item.time} осталось только{" "}
      {addNumWord(item.available, ["ракетка", "ракетки", "ракеток"])}
    </li>
  ));

  return (
    <>
      {isOpenModalNoSelectedRackets && (
        <Modal
          title={ModalTexts.racketRent.errorNoSelectedRackets.TITLE}
          subTitle={ModalTexts.racketRent.errorNoSelectedRackets.SUB_TITLE}
          isOpen={isOpenModalNoSelectedRackets}
          setIsOpen={setIsOpenModalNoSelectedRackets}
        >
          <Button
            newStyles={styles.button}
            onClickFunc={() => setIsOpenModalNoSelectedRackets(false)}
          >
            Назад
          </Button>
        </Modal>
      )}

      {isOpenModalUnavailable && (
        <Modal
          title={ModalTexts.racketRent.errorUnAvailable.TITLE}
          subTitle={ModalTexts.racketRent.errorUnAvailable.SUB_TITLE}
          isOpen={isOpenModalUnavailable}
          setIsOpen={setIsOpenModalUnavailable}
        >
          <ul className={styles.unavailable}>{unavailableQuantityList}</ul>
          <Button newStyles={styles.button} onClickFunc={onCloseUnavailable}>
            Назад
          </Button>
        </Modal>
      )}
    </>
  );
};

